import { useClaims } from "../../modules/generic/hooks/use-claims";
import { usePermissionOverrides } from "./use-permission-overrides";

import type { UUID } from "../../utils/uuid";

export interface Permissions {
  editable_program: readonly UUID[];
  read_only_program: readonly UUID[];
  ce_admin: boolean;
  super_admin: boolean;
  reviewer: boolean;
}

const defaultPermissions: Permissions = {
  editable_program: [],
  read_only_program: [],
  ce_admin: false,
  super_admin: false,
  reviewer: false,
};

export function usePermissions(): Permissions & { isLoading: boolean } {
  const user = useClaims();

  const { overrides } = usePermissionOverrides();

  if (!user) return { ...defaultPermissions, isLoading: true };

  return {
    editable_program: user["http://changeengine.com/editable_program"] ?? [],
    read_only_program: user["http://changeengine.com/read_only_program"] ?? [],
    ce_admin: user["http://changeengine.com/ce_admin"],
    super_admin: user["http://changeengine.com/super_admin"],
    reviewer: user.role === "reviewer",
    isLoading: false,
    ...overrides,
  };
}
